document.addEventListener('DOMContentLoaded', function() {
    document.querySelector('span.sizechart').addEventListener('click', function() {
      document.querySelector('.sizechart-overlay').classList.add('show-overlay');
      document.querySelector('.product-sizechart').classList.add('show-chart');
    });
    
    document.querySelector('.close-popup a').addEventListener('click', function() {
      document.querySelector('.sizechart-overlay').classList.remove('show-overlay');
      document.querySelector('.product-sizechart').classList.remove('show-chart');
    });

                           document.querySelector('.sizechart-overlay').addEventListener('click', function() {
                             document.querySelector('.sizechart-overlay').classList.remove('show-overlay');
      document.querySelector('.product-sizechart').classList.remove('show-chart');
                           });
});